const LessonManagePage = () => {
  return <div>Lesson Dashboard</div>;
};

export default LessonManagePage;
